module.exports = __webpack_public_path__ + "static/kartchen-ortsanbindung3-ee50eb7af02272d6e189b880679e3f61.png";